import { render, staticRenderFns } from "./account_list.vue?vue&type=template&id=37dc484e&scoped=true&"
import script from "./account_list.vue?vue&type=script&lang=js&"
export * from "./account_list.vue?vue&type=script&lang=js&"
import style0 from "./account_list.vue?vue&type=style&index=0&id=37dc484e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc484e",
  null
  
)

export default component.exports